<template lang="pug">
.explore
  h2.h-l.explore-title
    | explore
  .exploreContainer
    swiper(:options="swiperOption" ref="gallery")
      swiper-slide(v-for="item in explore" :key="item.text")
        a(:href="item.link")
          .slide
            img.cover(:src="item.image_url" :alt="item.text")
            .gradient
          h2.h-ml(v-html="item.text")
      .swiper-button-prev(slot="button-prev")
      .swiper-button-next(slot="button-next")
</template>

<script>

export default {
  name: 'home-explore',

  props: ['explore'],

  data () {
    return {
      swiperOption: {
        notNextTick: true,
        autoplay: false,
        direction: 'horizontal',
        prevButton: '.swiper-button-prev',
        nextButton: '.swiper-button-next',
        mousewheelControl: false,
        observeParents: true,
        debugger: true
      }
    }
  },

  computed: {
    swiper: function () {
      return this.$refs.gallery.swiper
    }
  }
}
</script>

<style lang="sass">
@import '../../styles/_variables'
@import '../../styles/_mixins'
.explore
  .explore-title
    padding-left: 0
    margin-left: $sectionMargin
    margin-bottom: 4rem
  .exploreContainer
    width: 75vW
    margin: auto
    @include respond-to(xs)
      width: 90%
    h2, .swiper-slide, .slide
      width: 65vW
      @include respond-to(xs)
        height: 48vW
        width: 90vW
    h2
      color: #FFF
      margin: 0
      width: calc(65vw - 6rem)
      position: absolute
      padding: 3rem
      padding-top: 9rem
      bottom: 0
      opacity: 0
      pointer-events: none
      @include transition(opacity, 0.25s, ease-in-out)
      @include respond-to(xs)
        opacity: 1
        padding: 0
        padding-left: 5%
        bottom: 1.2rem
        width: 90%
        height: auto
    .swiper-slide
      display: flex
      justify-content: center
    .slide
      position: relative
      &:hover + h2
        opacity: 1
      &:hover
        .gradient
          opacity: 1
          @include transition(opacity, 0.25s, ease-in-out)
      .gradient
        opacity: 0
        height: 65vH
        width: 100%
        position: absolute
        top: 0
        @include transition(opacity, 0.25s, ease-in-out)
        background: linear-gradient(rgba(255,255,255,0), rgba(0,0,0,0.9))
        @include respond-to(xs)
          opacity: 1
          height: 52vW
    .slide
      height: 65vH
      @include respond-to(xs)
        height: 52vW
    .swiper-button-prev
      background-image: url('/static/icons/left_arrow.svg')
      @include respond-to(xs)
        display: none
    .swiper-button-next
      background-image: url('/static/icons/right_arrow.svg')
      @include respond-to(xs)
        display: none
</style>



// WEBPACK FOOTER //
// HomeExplore.vue?44083c55